import { sendGet, sendPost } from "../base";
import { getAPIData } from "../helpers";
import { NotificationType } from "~/types/notifications";

export const getNotifications = () => getAPIData(sendGet("notifications/all/"));

export const postMarkAllRead = () =>
  getAPIData(sendPost(`notifications/mark-all-read/`));

export const postMarkRead = (notificationId: number) =>
  getAPIData(sendPost(`notifications/mark-read/${notificationId}/`));

export const createNotification = (notificationData: {
  title: string;
  message: string;
  type: NotificationType;
  primary_action_text?: string;
  primary_action_url?: string;
  secondary_action_text?: string;
  secondary_action_url?: string;
}) => getAPIData(sendPost("notifications/create/", notificationData));
